// extracted by mini-css-extract-plugin
export default {"blocks":"ClientComments_blocks__RXCvF"};